// Polyfill pro ES6
import 'core-js/es6/array';
//	import 'core-js/es6/date';
//	import 'core-js/es6/function';
//	import 'core-js/es6/index';
//	import 'core-js/es6/map';
//	import 'core-js/es6/math';
//	import 'core-js/es6/number';
import 'core-js/es6/object';
//	import 'core-js/es6/parse-float';
//	import 'core-js/es6/parse-int';
import 'core-js/es6/promise';
//	import 'core-js/es6/reflect';
//	import 'core-js/es6/regexp';
//	import 'core-js/es6/set';
//	import 'core-js/es6/string';
//	import 'core-js/es6/symbol';
//	import 'core-js/es6/typed';
//	import 'core-js/es6/weak-map';
//	import 'core-js/es6/weak-set';

// Polyfill pro ES2016
import 'core-js/es7/array';
//	import 'core-js/es7/asap';
//	import 'core-js/es7/error';
//	import 'core-js/es7/index';
//	import 'core-js/es7/map';
//	import 'core-js/es7/math';
import 'core-js/es7/object';
//	import 'core-js/es7/observable';
//	import 'core-js/es7/reflect';
//	import 'core-js/es7/set';
//	import 'core-js/es7/string';
//	import 'core-js/es7/symbol';
//	import 'core-js/es7/system';



// WEBPACK FOOTER //
// ./src/polyfill.js